import ListSectionRuleNote from './ListSectionRuleNote.component';

export default ListSectionRuleNote;
